exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notas-fiscais-tabs[data-v-79b2bb36]{margin-bottom:20px}.notas-fiscais-tabs .tab-btn[data-v-79b2bb36]{padding:10px 20px;margin-right:8px;border:1px solid #ddd;background:#fff;cursor:pointer;border-radius:4px}.notas-fiscais-tabs .tab-btn.active[data-v-79b2bb36]{background:#337ab7;color:#fff;border-color:#337ab7}.notas-fiscais-content .filters h3[data-v-79b2bb36]{margin-top:0;margin-bottom:16px}.notas-fiscais-content .input-with-date[data-v-79b2bb36],.notas-fiscais-content .input-with-date input[data-v-79b2bb36]{width:100%}.detail-nf-json[data-v-79b2bb36]{max-height:400px;overflow:auto;font-size:12px;white-space:pre-wrap;word-break:break-all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79b2bb36","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/restricted/payment/notasFiscais/NotasFiscais.vue
// module id = 1577
// module chunks = 0